var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.691 .039)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.364,
    cy: 32.364,
    r: 32.364,
    fill: "#000",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8AB7E9",
    opacity: 0.904,
    d: "M22.375 17.98l24.374 14.584-24.374 14.584z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NiIgaGVpZ2h0PSI2NiIgdmlld0JveD0iMCAwIDY2IDY2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC42OTEgLjAzOSkiPgogICAgPGNpcmNsZSBjeD0iMzIuMzY0IiBjeT0iMzIuMzY0IiByPSIzMi4zNjQiIGZpbGw9IiMwMDAiIG9wYWNpdHk9Ii41MDUiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiM4QUI3RTkiIHBvaW50cz0iMjIuMzc1IDE3Ljk4IDQ2Ljc0OSAzMi41NjQgMjIuMzc1IDQ3LjE0OCIgb3BhY2l0eT0iLjkwNCIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgIconPlay as ReactComponent };